<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="导入面试人员"
    width="700px"
  >
    <div class="top">
        <el-row>
          <el-col :span="12">
            <el-input placeholder="请输入名称搜索" v-model="searchFormData.name" class="input-with-select">
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </el-col>
          <el-col :span="12" class="invite">
              <div @click="phoneInvite" style="cursor: pointer;">
                <span>手机号邀请</span>
                <img src="@/assets/image/audition-phone.png"></img>
              </div>
              <div @click="ewmInvite" style="cursor: pointer;">
                <span>二维码邀请</span>
                <img src="@/assets/image/audition_ewm.png"></img>

              </div>
          </el-col>
        </el-row>
    </div>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="通讯录" name="one">
          <div class="res_box">
              <import-item v-for="item in onePageProps.records"
              :key="item.id" 
              :obj="{
                 name:item.friend_user_name,
                user_avatar:item.user_avatar,
                user_app_id:item.friend_user_app_id,
                jz_number:item.friend_jz_number,
              }"
              @invite="invite(item.friend_user_app_id,item)"
              :id="item.id">
              </import-item>
            </div>

            <!-- Pagination 分页 -->
            <!--<div class="table_form_bottom">
              <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="onePageProps.total"
              :page-size="onePageProps.pageSize"
              :page-sizes="[5, 10, 50, 100]"
              :current-page="onePageProps.pageNum"
              @size-change="handleOneSizeChange"
              @current-change="handleOneCurrentChange"
            />
            </div>-->
        </el-tab-pane>
        <el-tab-pane label="好友" name="two">

          <div class="res_box">
              <import-item v-for="item in twoPageProps.records"
              :key="item.id" 
              :obj="{
                 name:item.friend_user_name,
                user_avatar:item.user_avatar,
                user_app_id:item.friend_user_app_id,
                jz_number:item.friend_jz_number,
              }"
              @invite="invite(item.friend_user_app_id,item)"
              :id="item.id">
              </import-item>
            </div>
        </el-tab-pane>
        <el-tab-pane label="我推广的" name="three">

          <div class="res_box">
              <import-item v-for="item in threePageProps.records"
              :key="item.id" 
              :obj="{
                 name:item.alias_name,
                user_avatar:item.user_avatar,
                user_app_id:item.user_app_id,
                jz_number:item.jz_number,
              }"
              @invite="invite(item.user_app_id,item)"
              :id="item.id">
              </import-item>
            </div>
        </el-tab-pane>
        <el-tab-pane label="我的关注" name="four">

          <div class="res_box">
              <import-item v-for="item in fourPageProps.records"
              :key="item.id" 
              :obj="{
                 name:item.follow_alias_name,
                user_avatar:item.follow_user_avatar,
                user_app_id:item.follow_user_app_id,
                jz_number:item.jz_number,
              }"
              @invite="invite(item.follow_user_app_id,item)"
              :id="item.id">
              </import-item>
            </div>
        </el-tab-pane>
        <el-tab-pane label="关注我的" name="five">

          <div class="res_box">
              <import-item v-for="item in fivePageProps.records"
              :key="item.id" 
              :obj="{
                 name:item.fans_alias_name,
                user_avatar:item.fans_user_avatar,
                user_app_id:item.follow_user_app_id,
                jz_number:item.user_app_id,
              }"
              @invite="invite(item.user_app_id,item)"
              :id="item.id">
              </import-item>
            </div>
        </el-tab-pane>

    </el-tabs>
    </div>

    <!--
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </span>
-->

    <invite-dialog ref="refInviteDialog" @refresh="refreshData" ></invite-dialog>
    <invite-phone-dialog ref="refPhoneDialog" ></invite-phone-dialog>
    <invite-ewm-dialog ref="refEwmDialog" ></invite-ewm-dialog>

  </el-dialog>
</template>

<script scoped>
import { peoples,extension_peoples,follow_peoples,fans_peoples} from "@/api/user/index";
import importItem from './import-item.vue'
import inviteDialog from "@/views/director/audition/invite-dialog.vue";
import invitePhoneDialog from "@/views/director/audition/invite-phone-dialog.vue";
import inviteEwmDialog from "@/views/director/audition/invite-ewm-dialog.vue";



export default {

  components: {
    importItem,inviteDialog,invitePhoneDialog,inviteEwmDialog
  },


  data () {
    return {
      activeName:"one",
      visible: false,
      dialogFormData: {
      
      },
      project_id:'',
      job_id:'',
      searchFormData:{
        name:'',
      },

    

      onePageProps: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
     


      twoPageProps: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },



      threePageProps: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },



      fourPageProps: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },


      fivePageProps: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },

      searchFormData: {
        name: "",
        project_id:"",
        job_id:"",
        page: 0,
        limit: 0,
      },

    };
  },


  destroyed(){
    this.handleClose();
  },
  
  methods: {
    handleClose() {
      this.$emit("refresh");
      this.visible = false;

    },

    handleClick(tab, event) {
      console.log(tab, event);
    },


     //邀请
     invite(user_id,item){
      var that=this;
      this.$refs.refInviteDialog.init(user_id,that.project_id,that.job_id);

    },
    
    phoneInvite(){
      var that=this;

      this.$refs.refPhoneDialog.init(that.project_id,that.job_id);

    },

     
    ewmInvite(){
      var that=this;

      this.$refs.refEwmDialog.init(that.project_id,that.job_id);

    },
    

    init(project_id,job_id) {
      this.visible = true;
      this.project_id=project_id;
      this.job_id=job_id;

      this.oneData();
      this.twoData();
      this.threeData();
      this.fourData();
      this.fiveData();
    
    },

    refreshData(){
      //this.oneData();
      //this.twoData();
      //this.threeData();
      //this.fourData();
      //this.fiveData();

    },
    
    oneData(){
      var that = this;
      peoples(that.searchFormData).then((response) => {
        console.log("response.data",that.onePageProps);
        that.onePageProps.records = response.data;
       // that.onePageProps.total = response.data.total;
      });
    },

    twoData(){
      var that = this;
      peoples(that.searchFormData).then((response) => {
       // console.log(response);
        that.twoPageProps.records = response.data;
        //that.twoPageProps.total = response.data.total;
      });
    },

    threeData(){
      var that = this;
      extension_peoples(that.searchFormData).then((response) => {
        //console.log(response);
        that.threePageProps.records = response.data;
        //that.threePageProps.total = response.data.total;
      });
    },

    fourData(){
      var that = this;
      follow_peoples(that.searchFormData).then((response) => {
       // console.log(response);
        that.fourPageProps.records = response.data;
        //that.fourPageProps.total = response.data.total;
      });
    },

    fiveData(){
      var that = this;
      fans_peoples(that.searchFormData).then((response) => {
       // console.log(response);
        that.fivePageProps.records = response.data;
       // that.fivePageProps.total = response.data.total;
      });
    },


    // 当前页变更
    handleOneCurrentChange(num) {
      this.onePageProps.pageNum = num
      this.oneData();
    },
    // 每页显示页面数变更
    handleOneSizeChange(size) {
      this.onePageProps.pageSize = size
      this.oneData();
    },



    // 当前页变更
    handleTwoCurrentChange(num) {
      this.twoPageProps.pageNum = num
      this.twoData();
    },
    // 每页显示页面数变更
    handleTwoSizeChange(size) {
      this.twoPageProps.pageSize = size
      this.twoData();
    },


    // 当前页变更
    handleThreeCurrentChange(num) {
      this.threePageProps.pageNum = num
      this.threeData();
    },
    // 每页显示页面数变更
    handleThreeSizeChange(size) {
      this.threePageProps.pageSize = size
      this.threeData();
    },



    // 当前页变更
    handleFourCurrentChange(num) {
      this.fourPageProps.pageNum = num
      this.fourData();
    },
    // 每页显示页面数变更
    handleFourSizeChange(size) {
      this.fourPageProps.pageSize = size
      this.fourData();
    },



    // 当前页变更
    handleFiveCurrentChange(num) {
      this.fivePageProps.pageNum = num
      this.fiveData();
    },
    // 每页显示页面数变更
    handleFiveSizeChange(size) {
      this.fivePageProps.pageSize = size
      this.fiveData();
    },

  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}




/*
.footer{
  display: flex;
  justify-content: center;
}*/


}

::v-deep .el-tabs__nav.is-top{
  width: 100%;
    
}


.res_box {
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 20px;
  min-height: 500px;
}

.invite{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 32px;
  line-height: 32px;
  div{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 20px;
    img{
      width: 24px;
    }

  }
}
</style>
